<script>
export default {
  props: {
    message: { type: String, required: true },
    color: { type: String, default: () => '' },
    timeout: { type: Number, default: () => 5000 },
    actionText: { type: String },
    actionFunction: { type: Function },
  },

  computed: {
    htmlMessage() {
      return this.message.replace(/\n/g, '<br>')
    },
  },

  data() {
    return {
      isOpen: true,
      isActionBusy: false,
    }
  },

  watch: {
    isOpen(to) {
      if (!to) {
        this.$emit('close')
      }
    },
  },

  methods: {
    async onAction() {
      if (!this.actionFunction) {
        this.isOpen = false
        return
      }

      this.isActionBusy = true
      try {
        await this.actionFunction()
      } finally {
        this.isActionBusy = false
        this.isOpen = false
      }
    },
  },
}
</script>

<template>
  <v-snackbar app :timeout="timeout" v-model="isOpen" :color="color">
    <div v-html="htmlMessage"></div>

    <template v-slot:action="{ attrs }">
      <v-btn text v-bind="attrs" :disabled="isActionBusy" :loading="isActionBusy" @click="onAction">
        {{ actionText || 'Close' }}
      </v-btn>
    </template>
  </v-snackbar>
</template>
